// auth.js
export const LOGOUT = 'LOGOUT'
export const UPDATE_USER = 'UPDATE_USER'
